import React,{useEffect} from "react";
import i18n from "i18n-js";
import { Container,Row,Col } from "react-bootstrap";
import ourStory from "../../../static/assets/images/about/our-story.png";

const Story = () => {

  return (
    <section className="mhh-bg-image approach-asha">
    <Container>
      <Row noGutters className="justify-content-center">
      <Col xs={12} sm={12} md={4} lg={4} xl={4} id='approach-asha-sec' className="mhh-target-img-mobile">
          <div className="text-center">
            <img src={ourStory} className="our-story-mob-img" />
          </div>
        </Col>
      <Col xs={12} sm={12} md={8} lg={8} xl={8}>
          <div>
            <h1>{i18n.t("our-story-heading")}</h1>
            <div>
              <p>{i18n.t("our-story-text1")}</p>
              <p>{i18n.t("our-story-text2")}</p>
              <p>{i18n.t("our-story-text3")}</p>
              <p>{i18n.t("our-story-text4")}</p>
            </div>
          </div>
        </Col>
        <Col xs={12} sm={12} md={4} lg={4} xl={4} id='approach-asha-sec' className="mhh-target-img-desk">
          <div className="text-center">
            <img src={ourStory} className="our-story-mob-img" />
          </div>
        </Col>
      </Row>
    </Container>
  </section>
  );
};
export default Story;
